export function getHoursInMilliseconds(hours: number): number {
  return hours * 3600 * 1000;
}

export function getTimeIntervalsArray(
  startTime: string,
  endTime: string,
  intervalMinutes: number
): Array<{ value: string; label: string }> {
  /**
   * Generates an array of time intervals that are used as options in the Select or similar components when time picker
   * components can't be used (ie. if we need to customize the dropdown menu of a time picker).
   *
   * The returned array is made up of objects with a value and label. The value is the time in HH:mm format and the label is the time in HH:mm format.
   *
   * @param startTime - The start time in HH:mm format.
   * @param endTime - The end time in HH:mm format.
   * @param intervalMinutes - The interval in minutes.
   * @returns An array of time options, with a value and label.
   */
  const times: Array<{ value: string; label: string }> = [];

  const [startHour, startMinute] = startTime.split(':');
  const [endHour, endMinute] = endTime.split(':');

  const startDate = new Date();
  startDate.setHours(Number(startHour), Number(startMinute), 0, 0);

  const endDate = new Date();
  endDate.setHours(Number(endHour), Number(endMinute), 0, 0);

  while (startDate <= endDate) {
    const hours = startDate.getHours().toString().padStart(2, '0');
    const minutes = startDate.getMinutes().toString().padStart(2, '0');
    times.push({ value: `${hours}:${minutes}`, label: `${hours}:${minutes}` });
    startDate.setMinutes(startDate.getMinutes() + intervalMinutes);
  }

  return times;
}
